// src/utils/logger.js
export function logEvent(type, details = {}) {
  try {
    const log = {
      type,
      details,
      timestamp: new Date().toISOString(),
      page: window.location.pathname,
      sessionId: localStorage.getItem("session_id") || null,
      user: localStorage.getItem("username") || null,
    };

    // Save to localStorage
    let logs = JSON.parse(localStorage.getItem("frontend_logs") || "[]");
    logs.push(log);
    localStorage.setItem("frontend_logs", JSON.stringify(logs));

    console.log("FRONTEND LOG:", log);

    // 🔥 Notify logs page immediately
    window.dispatchEvent(new Event("log-added"));

  } catch (err) {
    console.error("Logging failed:", err);
  }
}

let debounceTimers = {};

export function logEventDebounced(type, details = {}, delay = 500) {
  const key = type + JSON.stringify(details);

  clearTimeout(debounceTimers[key]);

  debounceTimers[key] = setTimeout(() => {
    logEvent(type, details);
  }, delay);
}

// 🔥 Returns exact before/after difference line-by-line
export function computePromptDiff(oldText = "", newText = "") {
  const oldLines = oldText.split("\n");
  const newLines = newText.split("\n");

  const diff = [];

  const maxLength = Math.max(oldLines.length, newLines.length);

  for (let i = 0; i < maxLength; i++) {
    const oldLine = oldLines[i] || "";
    const newLine = newLines[i] || "";

    if (oldLine !== newLine) {
      diff.push({
        line: i + 1,
        before: oldLine,
        after: newLine
      });
    }
  }

  return {
    totalLinesChanged: diff.length,
    changes: diff
  };
}

export function diffObjects(oldObj = {}, newObj = {}) {
  const changes = {};
  
  Object.keys({ ...oldObj, ...newObj }).forEach(key => {
    if (oldObj[key] !== newObj[key]) {
      changes[key] = { before: oldObj[key], after: newObj[key] };
    }
  });

  return {
    changedKeys: Object.keys(changes),
    changes
  };
}



